
const NEWS_RULES = {
        0: {
            respirations: [{lte3: 8}, {lt: 12},
                           {gt3: 24}, {gt2: 20}],
            o2_stats: [{lte3: 91}, {lt2: 94}, {lt: 96}],
            on_o2: [{eq2: 'y'}],
            temperature: [{lte3: 35}, {lt: 36.1}, {gte2: 39.1}, {gt: 38}],
            blood_pressure: [{lte3: 90}, {lt2: 101}, {lt: 111},
                             {gte3: 220}],
            pulse: [{gte3: 131}, {gte2: 111}, {gte: 91},
                    {lte3: 40},  {lt: 51}],
            avpu: [{eq3: 'v'}, {eq3: 'p'}, {eq3: 'u'}]
        }
    }


const NewsAgeRange = {
  0: '18+'
}


let NewsGroup = function(age) {
    return 0;
}

exports.rules = NEWS_RULES
exports.ageRange = NewsAgeRange
exports.group = NewsGroup
